import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Pisalni lestenec?",
  "description": "",
  "published": "2007-01-15T00:00:00.000Z",
  "redirect_from": ["/blog/pisalni-lestenec/swizec/320"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Ocitno lahko obstaja tudi taka stvar, kot je`}<a parentName="p" {...{
        "href": "http://inhabitat.com/2007/01/10/bic-ballpoint-pen-chandelier/"
      }}>{` lestenec`}</a>{` narejen iz cisto navadnih kulijev, ki je povrhu vsega se prav prijeten za oko. Najvecje presenecenje lezi v tem, da si drznejo zanj zaracunati 1000 ameriskih dolarjev.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      